import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { crmApi, tokenStore, apiErrorMsg } from "./crmApi";

const AuthCtx = createContext(null);

export function CrmAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!tokenStore.get()) { setUser(null); return; }
    try {
      const { data } = await crmApi.get("/auth/me");
      setUser(data);
    } catch (err) {
      console.warn("CRM session check failed:", apiErrorMsg(err));
      tokenStore.clear();
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await crmApi.post("/auth/login", { email, password });
      tokenStore.set(data.token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(apiErrorMsg(e));
      return false;
    }
  };

  const logout = async () => {
    try {
      await crmApi.post("/auth/logout");
    } catch (err) {
      console.warn("CRM logout request failed (clearing local session anyway):", apiErrorMsg(err));
    }
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, error, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useCrmAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useCrmAuth must be inside CrmAuthProvider");
  return ctx;
}
